import React from 'react';

const SupportPage = () => {
  return <>SupportPage</>;
};

export default SupportPage;
